module.exports = __webpack_public_path__ + "static/media/microsoft.42dfd44b.png";